__webpack_require__.p = "/tmnc-pc/";